import { useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { getAllCitiesService } from "../services/GetAllCitiesService";
import { useAuth } from "../Providers/AuthProvider";
import { useQuery } from "@tanstack/react-query";

const MultiAutoCompleteCityPicker = ({ name, label, formik, reqiuerd }) => {
  const { stateAuth } = useAuth();

  const [options, setOptions] = useState([]);

  const { data, isLoading, error } = useQuery(
    ["cities"],
    () =>
      getAllCitiesService({
        headers: {
          token: stateAuth,
        },
      }),
    {
      //refetchOnMount: false,
      onSuccess: (data) => {
        const temOptions = data?.data?.map((option) => ({
          label: option.City_Persian,
          value: option.Id,
        }));
        setOptions(temOptions);
      },
    }
  );

  const handleChange = (event, value) => {
    formik.setFieldValue(name, value);
  };

  if (isLoading) {
    return <p>در حال بارگذاری</p>;
  }
  if (error && data.data.length === 0) {
    return <p>{error}</p>;
  }
  return (
    <>
      <div className="w-full flex flex-wrap min-h-[40px] content-start multiAutoComplete">
        <label className="mb-2 text-sm w-full">
          {label} {reqiuerd ? <span className="text-red-700">*</span> : ""}
        </label>
        <Autocomplete
          multiple
          id="tags-standard"
          name={name}
          className="min-h-10 flex-[2] rounded focus:outline-lightGreenKite !p-0"
          value={formik.values[name]}
          onChange={handleChange}
          options={options}
          getOptionLabel={(option) => option.label}
          //filterSelectedOptions
          //getOptionSelected={(option, value) => option.label === value.label}
          renderInput={(params) => {
            return <TextField {...params} placeholder={label} />;
          }}
        />
      </div>
    </>
  );
};

export default MultiAutoCompleteCityPicker;
